module.exports = __webpack_public_path__ + "static/media/MBAMarketing.6bc1457e.JPG";